import {MESSAGE_COUNT, MESSAGE_TAB_OPTIONS} from '../actions/Index';

// Defining the initial state for the reducer
const initState = {
  groupId: null,
  count: null,
  message_tab_options: {}
};

export default function (state = initState, action: any): any {
  const {type, payload} = action;
  switch (type) {
    case MESSAGE_COUNT:
      return {
        ...state,
        count: payload.count,
        groupId: payload.groupId
      };
    case MESSAGE_TAB_OPTIONS:
      return {
        ...state,
        message_tab_options: payload
      };
    default:
      return state;
  }
}
